module.exports = __webpack_public_path__ + "static/media/member.f60c6519.png";